import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    // Only scroll to top if the pathname actually changed
    if (prevPathname.current !== pathname) {
      console.log(`ScrollToTop: Navigating from ${prevPathname.current} to ${pathname}`);
      prevPathname.current = pathname;
      
      // Immediate instant scroll to top - no delays
      const scrollToTop = () => {
        console.log(`ScrollToTop: Scrolling to top for ${pathname}`);
        
        // Method 1: Instant scroll to top
        window.scrollTo(0, 0);
        
        // Method 2: Ensure document elements are also scrolled
        if (document.documentElement) {
          document.documentElement.scrollTop = 0;
        }
        if (document.body) {
          document.body.scrollTop = 0;
        }
      };

      // Execute immediately
      scrollToTop();
    }
  }, [pathname]);

  return null; // This component doesn't render anything
};

export default ScrollToTop; 